module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/toyota-ce10a19442dc970981d881ccb2fbafb4.png";